/* eslint sort-keys: "error" */

const de = {
  'about-service-feedback': 'Über diesen Service und Feedback',
  'about-services-feedback': 'Über diesen Service und Feedback',
  'about-these-pages': 'Über diese Webseiten',
  'about-this-service': 'Über diesen Service',
  access_with: 'Zugang mit',
  accessibility: 'Barrierefreiheit',
  'accessibility-limited': 'Rollstuhlgerecht',
  'accessibility-nolimit': 'Keine Einschränkungen',
  'accessibility-statement': 'Barrierefreiheit',
  'add-favourite-bikeStation-failed-heading': 'Speichern der Leihrad-Station fehlgeschlagen',
  'add-favourite-place-failed-heading': 'Ort konnte nicht gespeichert werden',
  'add-favourite-route-failed-heading': 'Route konnte nicht gespeichert werden',
  'add-favourite-station-failed-heading': 'Station konnte nicht gespeichert werden',
  'add-favourite-stop-failed-heading': 'Haltestelle konnte nicht gespeichert werden',
  'add-home': 'Zuhause setzen',
  'add-itinerary-via-point': 'Zwischenstopp hinzufügen',
  'add-location-to-favourites': 'Ort zu Favoriten hinzufügen',
  'add-to-favourites': 'Zu Favoriten hinzufügen',
  'add-via-button-label': 'Zwischenstopp hinzufügen',
  'add-via-duration-button-label': 'Aufenthaltszeit am Zwischenstopp {index}',
  'add-via-duration-button-label-close': 'Schließe Aufenthaltszeit-Auswahl am Zwischenstopp {index}',
  'add-via-duration-button-label-open': 'Öffne Aufenthaltszeit-Auswahl am Zwischenstopp {index}',
  'add-work': 'Arbeit setzen',
  address: 'Adresse',
  'address-or-stop': 'Adresse oder Haltestelle',
  agency: 'Betreiber',
  airplane: 'Flug',
  'airplane-with-route-number': 'Flug {routeNumber}',
  'airport-check-in': 'Gepäck bei {agency} einchecken',
  'airport-collect-luggage': 'Falls vorhanden, Gepäck einsammeln',
  'airport-security-check-go-to-gate': 'Gehen Sie durch die Sicherheitskontrolle zum Abfluggate',
  all: 'Alle',
  'all-routes': 'Alle Linien',
  'all-routes-disabled': 'Keine Linien',
  'alternative-legs': 'Alternativ {leg1} um {startTime1} und {leg2} um {startTime2}',
  'alternative-legs-single': 'Alternativ {leg1} um {startTime1}',
  'approx-meters': '{approxDistance} Meter',
  'aria-itinerary-summary':
    'Gesamtdauer {duration}. Route fährt ab {inFuture} {departureTime} mit Ankunft {arrivalTime}.',
  'aria-itinerary-summary-bike-distance': 'Strecke per Rad {duration}, {distance} ',
  'aria-itinerary-summary-car-distance': 'Strecke mit Auto {duration}, {distance} ',
  'aria-itinerary-summary-walk-distance': 'Strecke zu Fuß {duration}, {distance} ',
  'arrive-leave': 'Ankunft oder Abfahrt an der ausgewählten Zeit',
  'arriving-at': 'Ankunft',
  'arriving-soon': 'Jetzt',
  'as-destination': 'Zielort',
  'as-origin': 'Abfahrtsort',
  'as-viapoint': 'Zwischenstopp',
  'at-time': 'um',
  'avoid-transfers': 'Umstiege vermeiden',
  'avoid-walking': 'Gehen vermeiden',
  back: 'Zurück',
  'back-button-title': 'Zurück zur vorheringen Seite',
  'back-to-front-page': 'Zurück zur Startseite ›',
  bicycle: 'Fahrrad',
  'bicycle-distance-duration': 'Fahrrad {duration} ({distance})',
  'bicycle-walk-from-transit':
    'Nehmen Sie Ihr Fahrrad vom {transportMode} und schieben Sie es für {distance} ({duration})',
  'bicycle-walk-from-transit-no-duration': 'Schieben Sie Ihr Fahrrad vom {transportMode}',
  'bicycle-walk-to-transit':
    'Schieben Sie Ihr Fahrrad für {distance} ({duration}) und nehmen Sie es mit im {transportMode}',
  'bicycle-walk-to-transit-no-duration': 'Schieben Sie Ihr Fahrrad zum {transportMode}',
  bicycle_frame_lock: 'Rahmenverriegelung',
  bicycle_walk: 'Fahrrad schieben',
  'bike-availability': 'Fahrräder verfügbar',
  'bike-not-allowed-bus': 'Keine Fahrradmitnahme im Bus',
  'bike-not-allowed-tram': 'Keine Fahrradmitnahme in der Straßenbahn',
  'bike-only': 'Nur Fahrradfahren',
  'bike-park': 'Park & Ride für Fahrräder',
  'bike-park-disclaimer':
    'Sie können einfach Fahrradfahren und ÖPNV kombinieren: lassen Sie Ihr Fahrrad an der Park & Ride Stelle und fahren Sie mit Bus, Bahn, Tram oder Metro weiter. Das Parken des Fahrrads ist kostenlos und es gibt keine Zeitbegrenzung.',
  'bike-park-disclaimer-header': 'Parken Sie Ihr Fahrrad',
  'bike-park-disclaimer-link': 'Mehr über Park & Ride für Fahrräder erfahren',
  'bike-station-disabled': 'Pyöräasema ei ole käytössä.',
  'bikes-available': 'Fahrräder verfügbar',
  'biketransport-citybike': 'Ich benutze ein Leihrad',
  'biketransport-only-bike': 'Ich fahre nur mit dem Fahrrad',
  'biking-amount': 'Anteil der Radstrecke',
  'biking-speed': 'Geschwindigkeit mit dem Fahrrad',
  'book-a-lift': 'TODO',
  bus: 'Bus',
  'bus-express': 'Stammbus',
  'bus-express-with-route-number': 'Stammbus {routeNumber} {headSign}',
  'bus-local': 'Nachbarschaftsbus',
  'bus-with-route-number': 'Bus {routeNumber} {headSign}',
  buy: 'Buy',
  'buy-in-app': 'In der App kaufen',
  'buy-ticket': 'Ticket kaufen',
  call: 'Anrufen {number}',
  cancel: 'Abbrechen',
  canceled: 'Ausgefallen',
  'canceled-itineraries-amount':
    '{itineraryAmount, plural, =1 {1 weitere} other {{itineraryAmount} weitere}} ausgefallene Verbindungen',
  'canceled-itineraries-amount-hide': 'Ausgefallene Verbindungen ausblenden ({itineraryAmount})',
  'canceled-legs': 'Ausgefallene Abfahrten auf der Route',
  'capacity-modal.crushed-standing-room-only-body': 'Nur wenig Stehplätze verfügbar',
  'capacity-modal.crushed-standing-room-only-heading': 'Sehr voll',
  'capacity-modal.few-seats-available-body': 'Einige Sitzplätze verfügbar',
  'capacity-modal.few-seats-available-heading': 'Nicht zu voll',
  'capacity-modal.full-capacity-body': 'Keine Sitz- oder Stehplätze verfügbar',
  'capacity-modal.full-capacity-heading': 'Voll',
  'capacity-modal.heading': 'Gibt es Platz im Fahrzeug?',
  'capacity-modal.legend': 'Legende der Symbole',
  'capacity-modal.many-seats-available-body': 'Viele Sitzplätze verfügbar',
  'capacity-modal.many-seats-available-heading': 'Nicht überfüllt',
  'capacity-modal.standing-room-only-body': 'Nur wenige Sitzplätze und wenig Stehplätze verfügbar',
  'capacity-modal.standing-room-only-heading': 'Fast voll',
  'capacity-modal.subheading': 'Echtzeit-Kapazitätsinformationen sind für einige Fahrzeuge verfügbar',
  car: 'Auto',
  'car-distance-duration': 'Auto {duration} ({distance})',
  'car-distance-no-duration': 'Fahre {distance}',
  'car-drive-from-transit-no-duration': 'Fahren Sie Ihr Auto vom {transportMode}',
  'car-drive-to-transit-no-duration': 'Fahren Sie Ihr Auto zum {transportMode}',
  'car-park': 'Park & Ride',
  'car-park-disclaimer':
    'Sie können einfach Autofahren und ÖPNV kombinieren: lassen Sie Ihr Auto an der Park & Ride Stelle und fahren Sie mit Bus, Bahn, Tram oder Metro weiter. Das Parken des Autos ist kostenlos und es gibt keine Zeitbegrenzung.',
  'car-park-disclaimer-header': 'Parken Sie Ihr Auto',
  'car-park-disclaimer-link': 'Mehr über Park & Ride erfahren',
  cause: 'Grund',
  'char-left': 'Zeichen',
  'choose-freely': 'Optional',
  'choose-stop': 'Haltestelle auswählen',
  'choose-stop-or-vehicle': 'Select vehicle or stop',
  'choose-vehicle': 'Select vehicle',
  citybike: 'Leihrad',
  'citybike-buy-season': 'Ticket für Tag, Monat oder Jahr kaufen',
  'citybike-distance-duration': 'Leihrad {duration} ({distance})',
  'citybike-duration-general-header':
    'Extra Kosten fallen für mehrere Teile der Route an, um mit dem Leihrrad abgeschlossen werden zu können.',
  'citybike-duration-info':
    'Sie können ein Leihrad für {duration} Minuten am Stück fahren, danach fallen extra Kosten an.',
  'citybike-duration-info-header':
    'Der Teil der Route benötigt mehr als {duration} Minuten, um mit einem Leihrad abgeschlossen werden zu können.',
  'citybike-duration-info-short': 'Teil der Route dauert mehr als {duration} min. Extra Kosten fallen an.',
  'citybike-network-header': 'Leihräder und Scooter',
  'citybike-network-headers': 'Leihräder und Scooter',
  'citybike-purchase-link': 'Kaufen',
  'citybike-register-required': 'Anmeldung für Leihräder benötigt',
  'citybike-return-full': 'Leihrad zurückgeben?',
  'citybike-return-full-link': 'Leihrad zurückgeben, wenn eine Leihrad-Station voll ist ›',
  'citybike-start-using': 'Beginne Leihrad-Nutzung',
  'citybike-start-using-info': 'Mehr Informationen',
  'citybike-station': 'Leihrad-Station {stationId}',
  'citybike-station-no-id': 'Leihrad-Station',
  'clear-button-label': 'Leeren',
  close: 'Schließen',
  'close-favourite-module': 'Favoriten-Modul schließen',
  'close-settings': 'Fenster schließen und Einstellungen speichern',
  continue: 'Fortsetzen',
  'cookie-settings': 'Cookie Einstellungen',
  'copy-code': 'Code kopieren',
  covered: 'Überdacht',
  'create-account': '{contactName}-Konto anlegen',
  'create-embedded-search': 'Ein Routensuchelement anlegen',
  'create-stop-monitor': 'Haltestellen Monitor erstellen',
  'crushed-standing-room-only': 'Nur noch Stehplätze (sehr voll)',
  currentposition: 'Aktuelle Position',
  'cycle-distance-duration': 'Radfahren: {duration} ({distance})',
  'cyclewalk-distance-duration': 'Fahrrad schieben: {duration} ({distance})',
  datasources: 'Datenquellen',
  date: 'Datum',
  day: 'Tag',
  delete: 'Löschen',
  'delete-favourite-failed-heading': 'Favorit konnte nicht entfernt werden',
  'departure-list-update.sr-instructions':
    'Die Liste der der zukünftigen Abfahrten und Abfahrtszeiten wird in Echtzeit aktualisiert.',
  'departure-page-sr': 'Reise {shortName} {destination} {time} Information',
  'departure-time-in-minutes': '{minutes} min',
  'departure-time-sr': '{when} Uhr {time}. {realTime}',
  departures: 'Abfahrten',
  'departures-by-hour': 'Abfahrten je Stunde',
  'departures-by-hour-minutes-route': '(Minuten/Route)',
  'departures-not-found': 'Leider konnte kein Zeitplan für die gewählte Haltestelle gefunden werden.',
  'departures-not-found-time-threshold':
    'Leider konnte kein Zeitplan für die gewählte Haltestelle gefunden werden. Es ist möglich, dass die gewählte Zeit zu weit in der Zukunft liegt. Bitte versuchen Sie es später noch einmal.',
  description: 'Finde Verkehrsverbindungen zu allen Orten. Egal ob Nah oder Fern.',
  destination: 'Zielort',
  'destination-defined': 'Zielhaltestelle definiert',
  'destination-label-change': 'Zielort ändern',
  'destination-outside-service':
    'Leider konnte keine Route an diesen Zielort gefunden werden. Der Zielort befindet sich außerhalb des abgedeckten Gebietes. Bitte ändern Sie den Zielort.',
  'destination-placeholder': 'Wohin reisen?',
  'dialog-return-to-map': 'Zurück zur Karte',
  'digitransit-platform': 'Digitransit-Plattform',
  disclaimer:
    'Bitte beachten Sie, dass es sich um geschätzte Reisezeiten handelt. Die vorgeschlagenen Verbindungen können nicht garantiert werden.',
  disruption: 'Störung',
  'disruption-info': 'Störungsmeldungen',
  'disruption-info-no-alerts': 'Keine Störungsmeldungen.',
  'disruption-info-route-no-alerts': 'Keine Störungsmeldungen.',
  disruptions: 'Störungen',
  'disruptions-and-diversions': 'Sperrungen und Umleitungen',
  'disruptions-tab.sr-disruptions': 'Eine oder mehrere bekannte Störungen',
  'disruptions-tab.sr-no-disruptions': 'Keine Störungen bekannt',
  'distance-between': 'Abstand zwischen {distance1} m — {distance2} m',
  'distance-total': 'Gesamtstrecke',
  'distance-under': 'Abstand unter {distance} m',
  'e-scooter': 'E-Scooter',
  'e-scooter-alternative': 'Wie wäre es mit einem E-Scooter für einen Teil Ihrer Reise? {paymentInfo}',
  'e-scooter-disclaimer-close': 'E-Scooter-Hinweis schließen',
  'e-scooter-or-taxi-alternative':
    'Wie wäre es mit einem Taxi oder E-Scooter für einen Teil Ihrer Reise? {paymentInfo}',
  'e-scooter-station': 'E-Scooter-Station',
  'e-scooters': 'E-Scooter',
  'e-scooters-available':
    'Es sind E-Scooter in der Nähe verfügbar. Verwenden Sie eine App, um den E-Scooter zu entsperren.',
  earlier: 'Früher',
  'edit-favourites': 'Favoriten bearbeiten',
  'elevation-gained-total': 'Bergauf',
  'elevation-lost-total': 'Bergab',
  'embedded-search.choose-language': 'Sprache',
  'embedded-search.choose-mode': 'Transportmittel',
  'embedded-search.choose-width-component': 'Breite der Einbettung',
  'embedded-search.form-heading': 'Einbettungswerkzeuge',
  engine_ignition_aid: 'Zündstarthilfe',
  english: 'Englisch',
  explanations: 'Erklärung',
  'extra-info': 'Mehr Infos',
  'favourite-failed-text': 'Bitte versuchen Sie es später noch einmal.',
  'favourite-target': 'Favoriten',
  ferry: 'Fähre',
  'ferry-external': 'Fähre',
  'ferry-external-with-route-number': 'Fähre {routeNumber} {headSign}',
  'ferry-with-route-number': 'Fähre {routeNumber} {headSign}',
  'fetch-new-route': 'Neue Verbindung anfragen',
  'few-seats-available': 'Wenige Sitzplätze verfügbar',
  finnish: 'Finnisch',
  'free-of-charge': 'Kostenlos',
  'from-bus': 'Bus',
  'from-ferry': 'Fähre',
  'from-ferrypier': 'Fähranleger',
  'from-rail': 'Zug',
  'from-scooter-location': 'dem Scooter-Standort',
  'from-station': 'Bahnhof',
  'from-stop': 'Halt',
  'from-subway': 'U-Bahn',
  'from-tram': 'Tram',
  frontpage: 'Startseite',
  full: 'Voll',
  funicular: 'Seilbahn',
  'generic-cancelation': '{mode} {route} {headsign} um {time} wurde abgesagt.',
  'generic-error': 'Ein Fehler ist aufgetreten',
  'geolocate-yourself': 'Lokalisieren',
  'geolocation-denied-heading': 'Bitte Zugriff auf den Standort erlauben',
  'geolocation-denied-text':
    'Zugriff auf den Standort ist nicht erlaubt. Bitte prüfen Sie die Einstellungen Ihres Browsers.',
  'geolocation-failed-heading': 'Standortermittlung fehlgeschlagen',
  'geolocation-failed-text': 'Ihr Browser unterstützt keinen Zugriff auf den Standort',
  'geolocation-prompt-text': 'Bitte Zugriff auf den Standort erlauben',
  'geolocation-timeout-heading': 'Standortermittlung dauert länger als erwartet.',
  'geolocation-timeout-text': 'Abfahrtsort unten wählen, oder später versuchen.',
  'give-destination': 'Geben Sie Ihren Zielort ein',
  'give-name-to-location': 'Name für diesen Ort',
  'give-origin': 'Geben Sie Ihren Abfahrtsort ein',
  'give-position': 'Geben Sie Ihre Position ins Suchfeld ein.',
  'give-route': 'Verbindung suchen',
  hour: 'Stunde',
  'hour-short': 'h',
  'how-to-rate-service': 'Wie würden Sie den Service bewerten?',
  hsl_mobile_ticket: 'HSL Mobiles Ticket',
  hsl_ticket: 'HSL Ticket',
  hsl_travel_card: 'HSL Karte',
  'in-addition': 'auch',
  'include-estonia': 'Estland inkludieren',
  'index.title': 'Reiseplaner',
  inquiry: 'Feedback geben',
  instructions: 'Anweisungen',
  'is-open': 'Geöffnet:',
  'itinerary-co2.description':
    '{co2value} g CO₂-Emissionen werden auf dieser Reise erzeugt. Ein Auto würde {carCo2Value} g CO₂ auf der gleichen Strecke erzeugen.',
  'itinerary-co2.description-simple': '{co2value} g CO₂-Emissionen werden auf dieser Reise erzeugt.',
  'itinerary-co2.description-simple-sr': '{co2value} g Kohlendioxid-Emissionen werden auf dieser Reise erzeugt.',
  'itinerary-co2.description-sr':
    '{co2value} g Kohlendioxid-Emissionen werden auf dieser Reise erzeugt. Ein Auto würde {carCo2Value} g Kohlendioxid auf der gleichen Strecke erzeugen.',
  'itinerary-co2.link': 'So reduzieren wir Emissionen ›',
  'itinerary-co2.title': 'CO₂-Emissionen der Reise',
  'itinerary-co2.title-sr': 'Kohlendioxid-Emissionen der Reise',
  'itinerary-details.biking-leg':
    'Um {time} {distance} mit dem Rad von {origin} nach {destination} fahren. Geschätzte Dauer: {duration}',
  'itinerary-details.car-leg':
    'Um {time} {distance} mit dem Auto von {origin} nach {destination} fahren. Geschätzte Dauer: {duration}',
  'itinerary-details.end-leg': 'Um {time} am Ziel {destination} ankommen.',
  'itinerary-details.route-has-info-alert': 'Route enthält Warnungen.',
  'itinerary-details.route-has-severe-alert': 'Route enthält Störungen.',
  'itinerary-details.route-has-unknown-alert': 'Route enthält Störungen.',
  'itinerary-details.route-has-warning-alert': 'Route enthält Störungen.',
  'itinerary-details.scooter-leg':
    'Um {time} {distance} mit dem Scooter von {origin} nach {destination} fahren. Geschätzte Dauer: {duration}',
  'itinerary-details.transit-leg-part-1': 'Um {time} ',
  'itinerary-details.transit-leg-part-2': 'von {startStop} {trackInfo} nach {endStop}. Geschätzte Dauer: {duration}',
  'itinerary-details.via-leg': '{arrivalTime} Ankunft an der Zwischenhaltestelle {viaPoint}. {leaveAction}',
  'itinerary-details.walk-leg':
    'Um {time} {distance} zu Fuß von {origin} nach {destination} laufen. Geschätzte Dauer: {duration}',
  'itinerary-feedback-button': 'Feedback senden',
  'itinerary-feedback-message': 'Nichts gefunden?',
  'itinerary-feedback-placeholder': 'Beschreibung (optional)',
  'itinerary-hide-alternative-legs': 'Alternativen verbergen',
  'itinerary-hide-stops': 'Zwischenstopps ausblenden',
  'itinerary-in-the-past': 'Die Routensuche fällt in einen Zeitraum, der in der Vergangenheit liegt.',
  'itinerary-in-the-past-link': 'Abfahrt jetzt ›',
  'itinerary-in-the-past-title': 'Die Routenoptionen können nicht angezeigt werden',
  'itinerary-page.description': 'Reisebeschreibung',
  'itinerary-page.hide-details': 'Details ausblenden',
  'itinerary-page.itineraries-loaded': 'Suchergebnisse geladen',
  'itinerary-page.itineraries-updated': 'Suchergebnisse aktualisiert',
  'itinerary-page.loading-itineraries': 'Suchergebnisse werden geladen',
  'itinerary-page.show-details': 'Details zeigen',
  'itinerary-page.show-details-label': 'Zeige Details zu Routenvorschlag {number}',
  'itinerary-page.title': 'Reisebeschreibung',
  'itinerary-page.update-alert': 'Suchergebnisse aktualisiert',
  'itinerary-summary-page-street-mode.update-alert': 'Walking and biking results updated',
  'itinerary-summary-page.description': 'Reisevorschläge',
  'itinerary-summary-page.title': 'Routenvorschläge',
  'itinerary-summary-row.biking-distance': 'Gesamte Fahrradstrecke: {totalDistance}.',
  'itinerary-summary-row.clickable-area-description': 'Auf der Karte zeigen',
  'itinerary-summary-row.description':
    'Route fährt ab {departureDate} {departureTime} mit Ankunft {arrivalDate} {arrivalTime}. {firstDeparture} {transfers} Gesamte Dauer {totalTime}.',
  'itinerary-summary-row.first-departure': '{vehicle} fährt um {departureTime} von {stopName}.',
  'itinerary-summary-row.first-leg-start-time':
    'Fährt ab um {firstDepartureTime} von {firstDepartureStopType} {firstDepartureStop}',
  'itinerary-summary-row.first-leg-start-time-citybike': 'Abfahrt um {firstDepartureTime} von {firstDepartureStop} Leihrad-Station',
  'itinerary-summary-row.first-leg-start-time-scooter': 'Abfahrt um {firstDepartureTime} mit einem Scooter',
  'itinerary-summary-row.no-transit-legs': 'Start jederzeit möglich',
  'itinerary-summary-row.transfers': 'Umstieg auf {vehicle} an Halt {stopName}',
  'itinerary-summary-row.transfers-to-rental': 'Umstieg auf {vehicle}',
  'itinerary-summary-row.walking-distance': 'Gesamte Laufstrecke: {totalDistance}.',
  'itinerary-summary.bike-boarding-information':
    'Sie dürfen Ihr Fahrrad mit ins Fahrzeug nehmen. Erkundigen Sie sich beim Verkehrsunternehmen, ob für den Transport von Fahrrädern eine Gebühr anfällt.',
  'itinerary-summary.bikeAndPublic-bus-title': 'Nehmen Sie Ihr Rad mit in den Bus',
  'itinerary-summary.bikeAndPublic-ferry-title': 'Nehmen Sie Ihr Rad mit auf die Fähre',
  'itinerary-summary.bikeAndPublic-rail-subway-title': 'Nehmen Sie Ihr Rad mit in den Zug oder die Bahn',
  'itinerary-summary.bikeAndPublic-rail-title': 'Nehmen Sie Ihr Rad mit in den Zug',
  'itinerary-summary.bikeAndPublic-subway-title': 'Nehmen Sie Ihr Rad mit in die Bahn',
  'itinerary-summary.bikeAndPublic-tram-title': 'Nehmen Sie Ihr Rad mit in die Tram',
  'itinerary-summary.bikePark-title': 'Parken und Reisen',
  'itinerary-summary.car-boarding-information':
    'Sie können Ihr Auto mitnehmen. Erkundigen Sie sich beim Verkehrsunternehmen, ob eine zusätzliche Gebühr für den Transport von Autos anfällt.',
  'itinerary-summary.carAndPublic-ferry-title': 'Fahren Sie mit dem Auto zur Fähre',
  'itinerary-summary.carAndPublic-rail-title': 'Fahren Sie mit dem Auto zum Zug',
  'itinerary-summary.interline-wait': 'Warte auf den Umstieg in Fahrzeug ({time})',
  'itinerary-summary.interline-wait-multiple-legs':
    'Route ({shortName}) und Zielort werden sich mehrmals während der Reise ändern. Gesamte Wartezeit ist {time}. Bitte verlassen Sie nicht das Fahrzeug.',
  'itinerary-summary.show-on-map': 'Auf Karte zeigen {target}',
  'itinerary-ticket.title': 'Benötigte Fahrkarte',
  'itinerary-tickets.title': 'Benötigte Fahrkarten',
  'itinerary-time.title': 'Dauer',
  'itinerary-walk.title': 'Gesamte Laufstrecke',
  'journey-planner-manual': 'Routenplaner manuell',
  'journeyplanner.title': 'HSL Reiseplaner',
  'language-selection': 'Sprache: {language}',
  later: 'Später',
  'leave-your-car-park-and-ride': 'Lassen Sie Ihr Auto bei der Park & Ride Stelle',
  leaves: 'Abfahrt',
  'leaving-at': 'Abfahrt',
  lighting: 'Beleuchtung',
  'likely-to-recommend': 'Wie wahrscheinlich ist es, dass Sie unseren Service weiterempfehlen würden?',
  'likely-to-use':
    'Wie wahrscheinlich würden Sie weiterhin diesen Service anstatt des bisherigen Services nutzen?',
  loading: 'laden',
  localadmin: 'Ort',
  locate: 'Lokalisieren',
  'location-examples': 'z.B. Zuhause, Arbeit, Schule,...',
  'location-from-map': 'Gewählte Position',
  'location-from-map-confirm': 'Auswahl bestätigen',
  'location-home': 'Zuhause',
  'location-school': 'Schule',
  'location-shopping': 'Einkaufen',
  'location-sport': 'Sport',
  'location-work': 'Arbeit',
  login: 'Anmelden',
  'login-content': 'Um Favoriten, Linien und Haltestellen zu speichern, müssen Sie sich einloggen.',
  'login-header': 'Loggen Sie sich ein',
  logout: 'Abmelden',
  'long-transfers-margin': 'Lange',
  'main-menu-label-close': 'Hauptmenü schließen',
  'main-menu-label-open': 'Menü öffnen',
  'main-mode': 'Ich reise mit',
  'many-seats-available': 'Viele Sitzplätze verfügbar',
  map: 'Karte',
  'map-layer-citybike': 'Leihrad-Stationen',
  'map-layer-park-and-ride': 'Park & Ride-Plätze',
  'map-layer-park-and-ride-bike': 'Park & Ride Fahrradparkplätze',
  'map-layer-scooter': 'Scooter',
  'map-layer-stop-bus': 'Bushaltestellen',
  'map-layer-stop-ferry': 'Fähren',
  'map-layer-stop-funicular': 'Seilbahnen',
  'map-layer-stop-tram': 'Tramhaltestellen',
  'map-layer-terminal-bus': 'Busbahnhöfe',
  'map-layer-terminal-rail': 'Bahnhöfe',
  'map-layer-terminal-subway': 'U-Bahnhöfe',
  'map-layer-vehicles': 'Fahrzeuge',
  'map-zoom-in-button': 'Reinzoomen',
  'map-zoom-out-button': 'Herauszoomen',
  'menu-about-digitransit': 'Über Digitransit',
  'menu-copyright-nwsnet': '© die NetzWerkstatt GmbH & Co. KG {year}',
  'menu-copyright-prod': 'Das Schleswig-Holstein Navi ist ein gemeinsames Projekt des Kreises Schleswig-Flensburg und des Amtes Hüttener Berge - © {year}',
  'menu-faq': 'FAQ',
  'menu-feedback': 'Feedback senden',
  'menu-impressum': 'Impressum',
  'menu-link-to-privacy-policy': 'Datenschutz',
  'messagebar-label-close-message-bar': 'Banner schließen',
  'messagebar-label-page': 'Seite',
  'min-transfer-time': 'Umstiegszeit',
  'minute-short': 'm',
  minutes: 'min',
  'minutes-or-route': 'Min / Strecke',
  'mobile-ticket-purchase-aria':
    'Mobilticket Kaufinformationen. Kaufen Sie {ticketName} für {price}. Kaufen Sie das Ticket von der HSL app oder laden Sie die App herunter',
  'modes.from-place': 'vom Zielort',
  'modes.to-airplane': 'Flughafen',
  'modes.to-bike': 'Leihrad-Station',
  'modes.to-bike-park': 'Fahrrad Park',
  'modes.to-bus': 'Bushaltestelle',
  'modes.to-car-park': 'Auto Park',
  'modes.to-ferry': 'Fähranleger',
  'modes.to-place': 'Ziel',
  'modes.to-rail': 'Bahnhof',
  'modes.to-scooter': 'zum Scooter',
  'modes.to-stop': 'Haltestelle',
  'modes.to-subway': 'U-Bahn Station',
  'modes.to-tram': 'Tram Haltestelle',
  'more-departures': 'Weitere Abfahrten',
  'more-settings': 'Erweiterte Einstellungen',
  'move-on-map': 'Position auf der Karte hat sich geändert',
  'move-to-tab': 'Gehe zu Tab {number}',
  'navi-change-info': 'Sie erhalten Informationen über Änderungen',
  'navi-geolocation-approval': 'Ihre Zustimmung zur Standortfreigabe während der Nutzung des Dienstes',
  'navi-geolocation-details':
    'Beim Start der Navigation kann der Dienst um Ihre Zustimmung zur Standortfreigabe bitten. Sie können die Berechtigung jederzeit in den Einstellungen Ihres Geräts und Browsers ändern.',
  'navi-geolocation-purpose':
    'Durch die Freigabe Ihres Standorts erhalten Sie die bestmögliche Unterstützung auf Ihrer Route.',
  'navi-more-guidance': 'Noch bessere Navigation ans Ziel!',
  'navi-support': 'Sie erhalten Unterstützung auf Ihrer Route',
  'navidest-show-on-map': 'Route auf Karte anzeigen',
  navigate: 'Navigieren',
  'navigation-abort-trip': 'Leider ist Ihre Reiseplanung nicht möglich.',
  'navigation-description': 'Reiseführung',
  'navigation-get-mode': 'Steigen Sie in {mode} ein',
  'navigation-hurry-transfer': 'Kürzere Umstiegszeit',
  'navigation-hurry-transfer-solved': 'Umstiegszeit wieder normal',
  'navigation-hurry-transfer-solved-details': 'Umstiegszeit für {transfer} beträgt wieder {time}',
  'navigation-hurry-transfer-value': 'Umstiegszeit für {transfer} beträgt {time}',
  'navigation-interline-resume': 'Die Fahrt wird nach {duration} Wartezeit fortgesetzt',
  'navigation-interline-wait': 'Liniennummer {line} und Ziel {destination} ändern sich an der Haltestelle',
  'navigation-intro-begin': 'Navigation starten',
  'navigation-intro-header': 'Navigationseinführung',
  'navigation-intro-help-body': 'Hilfe zur Navigation',
  'navigation-intro-help-header': 'Hilfe',
  'navigation-intro-notifications-body': 'Benachrichtigungen zur Navigation',
  'navigation-intro-notifications-header': 'Benachrichtigungen',
  'navigation-journey-start': 'Ihre Reise beginnt um',
  'navigation-journey-start-early-prompt': 'Ihre Reise beginnt bald',
  'navigation-mode-canceled': '{name} wurde abgesagt',
  'navigation-mode-early': '{name} ist früher dran',
  'navigation-mode-late:': '{name} ist verspätet',
  'navigation-outro-dismiss': 'Navigator beenden',
  'navigation-outro-header': 'Reise beendet',
  'navigation-quit': 'Zurück',
  'navigation-remember-ticket': 'Haben Sie daran gedacht, ein Ticket zu kaufen?',
  'navigation-ticket': 'Ticket',
  'navigation-transfer-problem': 'Umstieg ist nicht mehr möglich',
  'navigation-transfer-problem-details': 'Umstieg {transfer} ist zu knapp.',
  'navileg-at-ferrypier': 'Fähranleger',
  'navileg-at-station': 'Bahnhof',
  'navileg-at-stop': 'Haltestelle',
  'navileg-bicycle': 'Radfahren nach',
  'navileg-car': 'Fahren nach',
  'navileg-departing-at': 'In {duration} um {legTime}',
  'navileg-hop-on': 'und einsteigen',
  'navileg-in-transit': '{mode}-Fahrt',
  'navileg-in-transit-interline':
    'Die Fahrt wird an {stopOrStation} {stop} im selben Fahrzeug in {duration} um {legTime} fortgesetzt',
  'navileg-intermediate-stops': '{stopCount} Zwischenstopps',
  'navileg-leave-at': 'Aussteigen an {stopOrStation} {stop} in {duration} um {legTime}',
  'navileg-mode-citybike': 'An der Station sind {available} Leihräder verfügbar',
  'navileg-mode-realtime': '{mode} {route} ist pünktlich',
  'navileg-mode-schedule': 'Keine aktuellen Verkehrsdaten verfügbar',
  'navileg-one-intermediate-stop': '{stopCount} Zwischenstopp',
  'navileg-rent-cycle': 'Leihrad ausleihen',
  'navileg-rent-scooter': 'Scooter ausleihen',
  'navileg-scooter': 'Mit dem Scooter fahren nach',
  'navileg-start-realtime': 'Abfahrt um {time} {stop} {stopName}',
  'navileg-start-schedule': '{mode} {route} planmäßige Abfahrt {time}',
  'navileg-walk': 'Gehen nach',
  nearest: '{ mode } in der Nähe',
  'nearest-favorites': 'Haltestellen in der Nähe',
  'nearest-favorites-browse-stops': 'Haltestellen durchsuchen und auswählen',
  'nearest-favorites-no-favorites': 'Zeitpläne für die ausgewählten Haltestellen und Fahrzeuge auf der Karte',
  'nearest-no-stops':
    'Es wurden keine Haltestellen oder Stationen für den ausgewählten Modus in der Nähe gefunden.',
  'nearest-stops': 'Nächstgelegene Haltestellen',
  'nearest-stops-airplane': 'Flughäfen',
  'nearest-stops-bus': 'Bushaltestellen',
  'nearest-stops-citybike': 'Fahrrad-Leihstationen',
  'nearest-stops-favorite': 'Haltestellen in meiner Nähe',
  'nearest-stops-ferry': 'Fähranleger',
  'nearest-stops-rail': 'Bahnstationen',
  'nearest-stops-subway': 'U-/Stadtbahn-Haltestelle',
  'nearest-stops-tram': 'Straßenbbahn-Haltestelle',
  'nearest-stops-update-location': 'Aktualisiere {mode}',
  'nearest-stops-updated-location': 'Position auf der Karte hat sich geändert',
  neighbourhood: 'Viertel ',
  'network-error': 'Ein Netzwerkfehler ist aufgetreten.',
  'new-route': 'Ist die Route neu für Sie?',
  next: 'Nächste',
  'no-bike-allowed-popup-train':
    'Die Fahrradmitnahme ist in Pendlerzügen erlaubt, in Fernverkehrszügen ist jedoch ein Zuschlag nötig und es könnte eine Reservierung erforderlich sein.',
  'no-bike-allowed-popup-tram-bus':
    'Die Fahrradmitnahme ist in Bussen und Straßenbahnen nicht erlaubt. Lassen Sie Ihr Fahrrad bitte an der Haltestelle oder an Park&Ride Plätzen, wenn Sie diese Verkehrsmittel benutzen. ',
  'no-departures': 'Keine Abfahrten',
  'no-more-route-msg': 'Keine weiteren Verbindungen gefunden',
  'no-position': 'Kein Standort',
  'no-position-no-stops':
    'Die nächsten Haltestellen können nicht gezeigt werden, da Ihr Standort unbekannt ist.',
  'no-route-already-at-destination': 'Sie sind schon an Ihrem Ziel.',
  'no-route-end': 'Bitte wählen Sie einen Zielort aus',
  'no-route-end-date-not-in-range': 'Der aktuelle Fahrplan enthält keine späteren Abfahrten.',
  'no-route-found': 'Leider kontte Route {shortName} ({longName}) nicht gefunden werden.',
  'no-route-msg':
    'Wir konnten leider keine Reisevorschläge für diese Strecke finden. Bitte versuchen Sie den Abfahrts- oder Zielort zu ändern.',
  'no-route-msg-time-threshold':
    'Leider konnten keine Routenvorschläge gefunden werden. Es ist möglich, dass noch keine Zeitpläne für den gewählten Tag gefunden wurden. Bitte versuchen Sie es später erneut',
  'no-route-msg-with-changes':
    'Leider wurden keine Reiseoptionen zu Ihrer Anfrage gefunden. Passen Sie Ihre Einstellungen, Abfahrt- oder Zielort an.',
  'no-route-origin-near-destination':
    'Die Entfernung zwischen Start und Ziel ist sehr gering. Bitte ändern Sie einen dieser Orte.',
  'no-route-origin-same-as-destination': 'Keine Reisevorschläge gefunden, da Abfahrts- und Zielort übereinstimmen.',
  'no-route-showing-alternative-options':
    'Keine Routenvorschläge mit Ihren Einstelllungen gefunden. Stattdessen haben wird die folgenden Reiseoptionen gefunden:',
  'no-route-start': 'Bitte wählen Sie einen Abfahrtsort aus',
  'no-route-start-date-too-early': 'Der aktuelle Fahrplan enthält keine früheren Abfahrten.',
  'no-route-start-end': 'Bitte Start und Ziel auswählen.',
  'no-transfers-margin': 'Keine',
  'no-trips-found': 'Keine Reisen für diesen Tag gefunden ({selectedDate}).',
  'notification-minimize': 'Mitteilung schließen',
  'notification-open': 'Mitteilung öffnen',
  now: 'Jetzt',
  'number-of-intermediate-stops':
    '{number, plural, =0 {Keine Zwischenstopps} one {1 Zwischenstopp} other {{number} Zwischenstopps} }',
  'number-of-minutes': '{number, plural, =0 {0 Minuten} one {1 Minute} other {{number} Minuten}}',
  'number-of-spaces': 'Anzahl Plätze:',
  'off-canvas-info':
    'Mit einer Anmeldung können Sie Favoriten speichern und auf anderen Geräten wieder verwenden.',
  'one-way-journey': 'Die Dauer einer Ein-Weg-Reise',
  'open-app': 'App öffnen',
  'open-operator-app': '{operator} App öffnen',
  'open-settings': 'Einstellungen öffnen',
  'option-default': 'Standard',
  'option-least': 'Am wenigsten',
  'option-less': 'Weniger',
  'option-more': 'Mehr',
  'option-most': 'Am meisten',
  or: 'oder',
  origin: 'Start',
  'origin-and-destination': 'Abfahrts- und Zielort',
  'origin-defined': 'Abfahrtsort definiert',
  'origin-label-change': 'Abfahrt ändern',
  'origin-outside-service':
    'Leider konnte keine Route von diesem Startort gefunden werden. Der Startort befindet sich außerhalb des abgedeckten Gebietes. Bitte ändern Sie den Startort.',
  'origin-placeholder': 'Start',
  'other-dates': 'Andere Daten',
  'own-position': 'Aktueller Standort',
  'page-not-found': 'Oh! Seite wurde nicht gefunden ੨( ･ ︵･ )ｼ',
  paid: 'Bezahlt',
  'park-and-ride': 'Park-and-Ride',
  'park-and-ride-availability': 'Plätze verfügbar',
  'park-and-ride-unknown': 'Unbekannte Kapazität',
  'pay-attention': 'Achtung',
  'payment-info-e-scooter':
    'Bitte beachten Sie, dass Sie die App des jeweiligen Anbieters benötigen, um die Scooter zu nutzen und zu bezahlen.',
  'payment-info-e-scooter-taxi':
    'Bitte beachten Sie, dass Sie die App des jeweiligen Anbieters benötigen, um Taxis oder Scooter zu nutzen und zu bezahlen.',
  'payment-info-taxi-lifts':
    'Bitte beachten Sie, dass die Nutzung und Bezahlung von Taxis und Fahrdiensten über die Apps der jeweiligen Anbieter erfolgt.',
  payment_at_gate: 'Bezahlung am Gate ',
  'pick-icon': 'Icon auswählen',
  'pick-mode': 'Verkehrsmittel auswählen',
  'pick-mode-airplane-disabled': 'Flug nicht ausgewählt',
  'pick-mode-airplane-enabled': 'Flug ausgewählt',
  'pick-mode-bus-disabled': 'Bus nicht ausgewählt',
  'pick-mode-bus-enabled': 'Bus ausgewählt',
  'pick-mode-citybike-disabled': 'Leihrad nicht ausgewählt',
  'pick-mode-citybike-enabled': 'Leihrad ausgewählt',
  'pick-mode-ferry-disabled': 'Fähre nicht ausgewählt',
  'pick-mode-ferry-enabled': 'Fähre ausgewählt',
  'pick-mode-rail-disabled': 'Zug nicht ausgewählt',
  'pick-mode-rail-enabled': 'Zug ausgewählt',
  'pick-mode-selected': 'Ausgewählte Transportmittel',
  'pick-mode-subway-disabled': 'U-Bahn nicht ausgewählt',
  'pick-mode-subway-enabled': 'U-Bahn ausgewählt',
  'pick-mode-tram-disabled': 'Tram nicht ausgewählt',
  'pick-mode-tram-enabled': 'Tram ausgewählt',
  'pick-street-mode': 'Meine Reiseoptionen',
  'place-route-or-keyword': 'Adresse oder Haltestelle',
  platform: 'Gleis',
  'platform-num': 'Gleis {platformCode}',
  'platform-short': 'Gl. {platformCode}',
  'platform-short-no-num': 'Gl.',
  polish: 'Polnisch',
  position: 'Position',
  'prefer-walking': 'Gehen bevorzugen',
  preview: 'Vorschau',
  previous: 'Vorherige',
  print: 'Drucken',
  'print-timetable': 'Fahrplan',
  'privacy-statement': 'Datenschutzerklärung',
  'public-transport': 'Öffentlicher Nahverkehr',
  rail: 'Zug',
  'rail-with-route-number': 'Zug {routeNumber} {headSign}',
  'read-more': 'Mehr erfahren',
  realtime: 'Echtzeit',
  'realtime-matching': 'Echtzeit-Matching',
  releases: 'Veröffentlichungen',
  'remove-favourite': 'Aus Favoriten entfernen',
  'remove-via-button-label': 'Zwischenstopp {index} entfernen',
  'rent-cycle-at': 'Fahrrad mieten bei:',
  'rent-e-scooter-at': 'Verwenden Sie eine App, um den E-Scooter zu entsperren',
  'rent-scooter-at': 'Scooter bei {station} ausleihen',
  'required-ticket': 'Benötigtes Ticket',
  'restore-default-settings': 'Standardeinstellungen wiederherstellen {changedSettingsIndicator}',
  'restore-default-settings-aria-label': 'Standardeinstellungen wiederherstellen.',
  'restore-default-settings-aria-label-done': 'Standardeinstellungen sind aktiv.',
  'return-cycle-to': 'Fahrrad zurückgeben bei:',
  'return-e-scooter-to': 'Stellen Sie den Scooter an einem sicheren Ort ab',
  'return-scooter-to': 'Scooter bei {station} zurückgeben',
  'right-now': 'Jetzt',
  route: 'Linie',
  'route-add-viapoint': 'Zwischenstopp',
  'route-custom-settings': 'Eigene Einstellungen',
  'route-default': 'Voreinstellungen',
  'route-destination-arrives': 'Nur Ausstieg',
  'route-destination-endpoint': 'Ankunft / Endstation',
  'route-fastest': 'Schnellste Route',
  'route-from-here': 'Route von hier',
  'route-guide': 'Routenplan',
  'route-here': 'Route hierher',
  'route-least-elevation-changes': 'Höhenunterschiede vermeiden',
  'route-least-transfers': 'Umstiege vermeiden',
  'route-least-walking': 'Wenig zu Fuß',
  'route-no-stop': 'Kein Halten',
  'route-not-possible': 'Leider konnte keine Route berechnet werden. Technischer Fehler: "{error}"',
  'route-page-vehicle-position': '{mode} {shortName} is at {stopName}',
  'route-page-vehicle-position-between': '{mode} {shortName} is between {stopName} and {nextStopName}',
  'route-page-vehicle-selected': 'Aktuelle Auswahl.',
  'route-page.description': 'Linie {shortName}, {longName}',
  'route-page.future-routes': 'Zukünftige Routen',
  'route-page.pattern-chosen': 'Ausgewählt',
  'route-page.pattern-select-title': 'Wählen Sie die Route aus, die angezeigt werden soll',
  'route-page.similar-routes': 'Sie könnten sich auch interessieren für',
  'route-page.special-routes': 'Andere Routen',
  'route-page.title': 'Route {shortName}',
  'route-page.title-short': 'Linie',
  'route-to-ferry': 'Route zum Anleger',
  'route-to-park': 'Route zum Park',
  'route-to-station': 'Route zur Station',
  'route-to-stop': 'Route zur Haltestelle',
  'router-change-departure-time': 'Abfahrtszeit ändern ›',
  'router-location-not-found': 'Bitte wählen Sie eine Position auf dem Straßennetz oder eine Haltestelle.',
  'router-location-not-found-title-1': 'Zugang zum Zielort nicht möglich',
  'router-location-not-found-title-2': 'Zugang zum Abfahrtsort nicht möglich',
  'router-location-not-found-title-3': 'Zugang zu Abfahrts- und Zielort nicht möglich',
  'router-only-walk': 'Keine schnelleren Alternativen als Laufen für die gewählte Route verfügbar.',
  'router-only-walk-title': 'Laufen Sie die Route',
  'router-outside-bounds-3':
    'Keine Routenvorschläge gefunden, da Abfahrts- und Zielort außerhalb des Service-Bereichs liegen.',
  'router-outside-service-period': 'Zeitplaninformationen sind für die gewählte Zeit nicht verfügbar.',
  'router-stops-in-range-1': 'Es gibt keine öffentlichen Halttestellen, die nah genug an dem Zielort liegen.',
  'router-stops-in-range-2':
    'Es gibt keine öffentlichen Halttestellen, die nah genug an dem Abfahrtsort liegen.',
  'router-stops-in-range-3':
    'Es gibt keine öffentlichen Halttestellen, die nah genug an dem Abfahrts- und Zielort liegen.',
  'router-system-error': 'Ein interner Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.',
  'router-transit-connection': 'Bitte versuchen, Abfahrts- oder Zielort zu ändern.',
  'router-transit-connection-in-search-window': 'Es sind keine Services zu der gewählten Zeit verfügbar.',
  'router-unable': 'Routeneinstellungen können nicht angezeigt werden',
  routes: 'Linien',
  'routes-platforms': 'Linien, Steige',
  'routes-tracks': 'Linien, Gleise',
  'routing-feedback-header': 'Sind Sie zufrieden mit den Routenvorschlägen?',
  'routing-feedback-link': 'Geben Sie Feedback',
  run: 'Schnell',
  save: 'Speichern',
  scooter: 'Scooter',
  'scooter-availability': 'Scooter sind jetzt an der Station verfügbar',
  'scooter-distance-duration': 'Scooter {distance} fahren ({duration})',
  'scooter-register-required': 'Um Scooter nutzen zu können, wird eine Anmeldung benötigt',
  'scooterwalk-distance-duration': 'Scooter {distance} schieben ({duration})',
  search: 'Suchen',
  'search-autosuggest-label':
    'Ort und Haltestellensuche. Liste mit Pfeiltasten navigieren, mit Enter-Taste auswählen',
  'search-autosuggest-label-instructions': 'Liste mit Pfeiltasten navigieren, mit Enter-Taste auswählen.',
  'search-autosuggest-label-move-to-destination': 'Nach Auswahl des Startorts werden Sie automatisch zum Zielfeld weitergeleitet.',
  'search-autosuggest-len': 'Es sind {len} Vorschläge verfügbar',
  'search-button-label': 'Suchen',
  'search-current-suggestion': 'Aktuelle Auswahl: {selection}',
  'search-destination': 'Suche Ziel, Linie oder Haltestelle',
  'search-destination-index': 'Geben Sie das Ziel ein',
  'search-destination-results-but-no-search': 'Siehe Ergebnisse im "Zielort"-Tab',
  'search-fields.sr-instructions':
    'Routen werden automatisch gesucht, wenn Abfahrtsort und Zielort eingegeben wurden. Änderungen der Suchparameter lösen eine neue Suche nach Routen aus.',
  'search-no-results': 'Keine Ergebnisse',
  'search-origin': 'Geben Sie Ihren Abfahrtsort ein',
  'search-origin-index': 'Geben Sie Ihren Abfahrtsort ein',
  'search-position': 'Standort suchen',
  'search-search-results-but-no-destination': 'Siehe Ergebnisse im "Linie oder Haltestelle"-Tab',
  'searching-position': 'Suche aktuellen Standort...',
  'select-all-routes': 'Alle Routen auswählen',
  'select-date': 'Datum auswählen',
  'select-from-map-destination': 'Ziel wählen',
  'select-from-map-favourite': 'Auf der Karte auswählen',
  'select-from-map-no-title': 'Kein Titel',
  'select-from-map-origin': 'Abfahrsort wählen',
  'select-from-map-viaPoint': 'Zwischenstopp wählen',
  'select-map-layers-header': 'Was soll auf der Karte angezeigt werden?',
  'select-position': 'Standort aus vorherigen Suchen wählen',
  'select-route': 'Wähle {mode} Route {shortName} zu {headsign}',
  'selected-routes': 'Ausgewählte Linien',
  send: 'Senden',
  'separate-ticket-required': 'Für einen Teil der Route ist ein seperates Ticket erforderlich.',
  'separate-ticket-required-disclaimer':
    'Die Route umfasst einen oder mehrere Abschnitte, für die {agencyName} keine Tickets verkauft.',
  'separate-ticket-required-for-call-agency-disclaimer':
    'Die Reise beinhaltet einen bedarfsgesteuerten Verkehr. Bitte prüfen Sie die Zahlungsmethoden und -bedingungen auf ',
  'set-specific-settings': 'Setze spezifischere Einstellungen',
  'set-stop-as-routes': 'Setze die Haltestelle als Routen',
  'set-time-earlier-button-label': 'Frühere Reisezeit wählen',
  'set-time-later-button-label': 'Spätere Reisezeit wählen',
  'set-time-now-button-label': 'Reisezeit ab jetzt',
  settings: 'Einstellungen',
  'settings-alternative-name-rail': 'Zug',
  'settings-change-itinerary-settings': 'Einstellungen ändern',
  'settings-dropdown-close-label': 'Schließe Einstellungen',
  'settings-dropdown-open-label': 'Öffne Einstellungen',
  'settings-e-scooter':
    'Sie können die gewünschten E-Scooter auswählen und sie in die Routenvorschläge aufnehmen. {paymentInfo}',
  'settings-e-scooter-on': 'E-Scooter dauerhaft in Ihren Einstellungen aktivieren',
  'settings-e-scooter-routes': 'Machen Sie E-Scooter zum Teil Ihrer Routen!',
  'settings-label-change': 'Einstellungen ändern',
  'settings-missing-itineraries-body': 'Einige Auswahlmöglichkeiten in den Einstellungen schließen bestimmte Routen aus.',
  'settings-missing-itineraries-header': 'Gibt es Routen Alternativen, die fehlen?',
  'settings-taxi-lift':
    'Sie können die gewünschten Taxi- und Fahrdienste auswählen, damit sie in die Routenplanung aufgenommen werden.',
  share: 'Reise teilen',
  show: 'zeigen',
  'show-departures': 'Abfahrten zeigen',
  'show-more': 'Mehr zeigen',
  'show-more-stops-near-you': 'Zeige mehr Haltestellen in der Nähe',
  'show-routes': 'Verbindungen auswählen',
  'skip-positioning': 'Überspringen',
  'skip-to-content': 'Zum Inhalt springen',
  slow: 'Langsam',
  'specify-location': 'Ort eingeben',
  speedtram: 'Stadtbahn',
  'speedtram-with-route-number': 'Stadtbahn {routeNumber} {headSign}',
  'splash-locating': 'Suche aktuellen Standort...',
  'splash-or-choose': 'oder einen dieser Abfahrtsorte wählen',
  'splash-use-positioning': 'Aktuellen Standort benutzen',
  'splash-welcome': 'Wie möchten Sie starten?',
  'splash-you-can-also': 'Sie können auch',
  'standing-room-only': 'Nur Stehplätze',
  station: 'Station',
  'station-entrance': 'Eingang',
  'station-exit': 'Ausgang',
  stop: 'Haltestelle',
  'stop-departure-time-future': 'Abfahrt in {minutes} Minuten',
  'stop-departure-time-past': 'Abfahrt war um',
  'stop-list-update.sr-instructions': 'Abfahrtszeiten für alle Haltestellen werden in Echtzeit aktualisiert.',
  'stop-near-you': 'Suche Haltestellen und Linien in der Nähe',
  'stop-near-you-modal-grant-permission': 'oder aktiviere die Ortsbestimmung',
  'stop-near-you-modal-grant-permission-info':
    'Sie können die Standortabfrage Ihres Smartphonse oder Browsers freigeben, so dass dieser Dienst Ihren aktuellen Standort verwenden kann.',
  'stop-near-you-modal-header': 'Sie haben die Standortabfrage nicht freigegeben.',
  'stop-near-you-modal-info':
    'Zur Nutzung der Suche nach Haltestellen in der Nähe wird Zugriff auf die Standortabfrage benötigt.',
  'stop-near-you-title': 'Suche nach Haltestellen oder Linien',
  'stop-near-you-update-alert': 'Nächste Haltestellen aktualisiert',
  'stop-number': 'Haltestellennummer',
  'stop-page.description': 'Haltestelle - {name} {code}, {desc}',
  'stop-page.right-now.loaded': 'Haltestellenseite geladen',
  'stop-page.title': 'Haltestelle - {name} {code}',
  'stop-page.title-short': 'Haltestelle',
  'stop-virtual-monitor': 'Virtueller Monitor',
  stops: 'Haltestellen',
  'stops-near-you.description': 'Stop timetables and vehicles near your',
  'stops-near-you.title': 'Near by stops timetables',
  street: 'Straße',
  'street-mode-bike-aria': 'Zeige Fahrradroute. Dauer {duration}, Strecke {length}',
  'street-mode-bikeandvehicle-aria': 'Zeige Kombination von Fahrrad und ÖPNV. Dauer {duration}, davon {length} per Rad',
  'street-mode-car': 'Auto',
  'street-mode-car-aria': 'Zeige Route mit Auto. Dauer {duration}, Strecke {length}',
  'street-mode-car_park': 'Park & Ride',
  'street-mode-carandvehicle-aria':
    'Zeige Route, die auch andere Verkehrsmittel wie Autofähren einschließen kann. Dauer {duration}, Strecke {length}',
  'street-mode-parkandride-aria': 'Zeige Park and Ride Route. Dauer {duration}, Strecke {length}',
  'street-mode-public_transport': 'ÖPNV',
  'street-mode-walk': 'Zu Fuß',
  'street-mode-walk-aria': 'Zeige Fußweg. Dauer {duration}, Strecke {length}',
  subway: 'U-Bahn',
  'subway-entrance.sr-description': 'U-Bahn-Eingang {entranceName}',
  'subway-entrance.sr-description.accessible': 'U-Bahn-Eingang {entranceName}, barrierefrei',
  'subway-exit.sr-description': 'U-Bahn-Ausgang {entranceName}',
  'subway-exit.sr-description.accessible': 'U-Bahn-Ausgang {entranceName}, barrierefrei',
  'subway-with-route-number': 'U-Bahn {routeNumber} {headSign}',
  'summary-page.description': '{from} - {to}',
  'summary-page.row-label': 'Reisevorschlag {number}',
  'summary-page.title': 'Reisevorschläge',
  surveillance_cameras: 'Videoüberwachung',
  'swap-order-button-label': 'Start und Ziel tauschen',
  swedish: 'Schwedisch',
  'swipe-disruption-info': 'Unterbrechungsinformation, wische Ergebnis Tabs',
  'swipe-disruption-info-header': 'Unterbrechungsinformation, wische Ergebnis Tabs.',
  'swipe-message-bar': 'Nachricht, wische Ergebnis Tabs',
  'swipe-message-bar-header': 'Nachricht, wische Ergebnis Tabs.',
  'swipe-result-tab-left': 'Swipe result tabs left arrow. Press Enter or Space to show the previous tab.',
  'swipe-result-tab-right': 'Swipe result tabs right arrow. Press Enter or Space to show the next tab.',
  'swipe-result-tabs': 'Switch tabs using arrow keys.',
  'swipe-sr-new-tab-opened': 'Tab {number} opened.',
  'swipe-stops-near-you': 'Haltestellen in der Nähe, wische Ergebnis Tabs.',
  'swipe-stops-near-you-header': 'Haltestellen in der Nähe, wische Ergebnis Tabs',
  'swipe-summary-page': 'Itinerary swipe result tabs',
  'swipe-summary-page-header': 'Itinerary swipe result tabs.',
  'terminal-page.description': 'Terminal - {name}',
  'terminal-page.title': 'Terminal',
  'terminal-page.title-short': 'Terminal - {name}',
  'terms-of-use': 'Nutzungsbedingungen',
  'ticket-and-price-info': 'Ticket- und Preisinformation',
  'ticket-single-adult': 'Erwachsener',
  'ticket-type-none': 'Keine Tarifzonenbeschränkung',
  tickets: 'Fahrkarten',
  time: 'Zeit',
  'time-navigation-buttons': 'Zeitnavigation',
  'time-selector-form': 'Zeit bearbeiten',
  'time-selector-hours-label': 'Stunde',
  'time-selector-minutes-label': 'Minute',
  timetable: 'Fahrplan',
  'to-bicycle': 'Fahrrad',
  'to-bus': 'Bus',
  'to-e-scooter': 'Scooter',
  'to-ferry': 'Fähre',
  'to-frontpage': 'Zur Startseite',
  'to-rail': 'Zug',
  'to-speedtram': 'Stadtbahn',
  'to-subway': 'U-Bahn',
  'to-tram': 'Tram',
  today: 'Heute',
  tomorrow: 'Morgen',
  track: 'Gleis',
  'track-num': 'Gleis {platformCode}',
  'track-short': 'Gl. {platformCode}',
  'track-short-no-num': 'Gl.',
  'tracking-button-off': 'Standortverfolgung aus',
  'tracking-button-offline': 'Standortverfolgung fehlgeschlagen',
  'tracking-button-on': 'Standortverfolgung an',
  traficom: 'Traficom',
  tram: 'Tram',
  'tram-local': 'Lokale Tram',
  'tram-with-route-number': 'Tram {routeNumber} {headSign}',
  transfer: 'Umstieg',
  transfers: 'Umstiege',
  'transfers-allowed': 'Umstiege erlauben',
  'transfers-margin': 'Umstiegszeit',
  'travel-time': '{min} min',
  'travel-time-label': 'Reisezeit',
  'travel-time-with-hours': '{h} h {min} min',
  'trip-co2-emissions': 'CO2-Emissionen der Reise',
  'trip-co2-emissions-sr': 'Kohlendioxid-Emissionen der Reise',
  'trip-information': 'Reiseinformationen',
  'trip-page.description': 'Linie {shortName}, {longName}',
  'trip-page.title': 'Linie {shortName}',
  'try-again': 'Nochmal versuchen',
  'use-citybike': 'Leihrad benutzen',
  'use-national-service-postfix': '.',
  'use-national-service-prefix': 'Wir empfehlen, dass Sie den überregionalen Routenplaner nutzen, ',
  'use-own-position': 'Aktuellen Standort benutzen',
  userinfo: 'Meine Informationen',
  usermenu: 'Nutzermenü',
  'using-modes': 'Verkehrsmittel',
  venue: 'Ort',
  'very-likely': 'Sehr wahrscheinlich',
  'very-unlikely': 'Sehr unwahrscheinlich',
  'via-leg-stop-duration': 'Am Zwischenstopp {stayDuration}',
  'via-point': 'Zwischenstopp',
  'via-point-index': 'Zwischenstopp {index}',
  'viapoint-slack-amount': 'Aufenthalt am Zwischenstopp',
  'view-route': 'Route anzeigen',
  vr_ticket: 'VR Ticket',
  wait: 'Wartezeit',
  'wait-amount-of-time': 'Wartezeit {duration}',
  'wait-in-vehicle': 'Warten Sie im Fahrzeug',
  walk: 'gehen',
  'walk-bike-itinerary-1': 'Ihre Suche ergab nur Fußweg-Routen.',
  'walk-bike-itinerary-2': 'Ihre Suche ergab nur Fahrrad-Routen.',
  'walk-bike-itinerary-3': 'Ihre Suche ergab nur Fußweg- und Fahrrad-Routen.',
  'walk-bike-itinerary-4': 'Ihre Suche ergab nur Fußweg- Fahrrad- und Auto-Routen.',
  'walk-distance-duration': 'Gehen {duration} ({distance})',
  'walk-only': 'Nur Laufen',
  walking: 'Gehen',
  'walking-speed': 'Laufgeschwindigkeit',
  'warning-call-agency': 'Nur auf Nachfrage: {routeName}, muss vorher angefragt werden.',
  'warning-call-agency-no-route': 'Nur auf Nachfrage. Diese Fahrt muss vorher angefragt werden.',
  weather: 'Wetter',
  'weather-at-destination': 'Wetter am Reiseziel',
  'weather-data-source': 'Quelle: Finnish Meteorological Institute',
  'weather-detail-title': 'Wettervorhersage für das Reiseziel um ',
  'weather-icon-1': 'Klar',
  'weather-icon-2': 'Bewölkt',
  'weather-icon-21': 'Leichte Schauer',
  'weather-icon-22': 'Schauer',
  'weather-icon-23': 'Starke Schauer',
  'weather-icon-3': 'Bewölkt',
  'weather-icon-31': 'Niesel',
  'weather-icon-32': 'Regen',
  'weather-icon-33': 'Starker Regen',
  'weather-icon-41': 'Leichte Schneeschauer',
  'weather-icon-42': 'Schneeschauer',
  'weather-icon-43': 'Starke Schneeschauer',
  'weather-icon-51': 'Leichter Schnee',
  'weather-icon-52': 'Schnee',
  'weather-icon-53': 'Starker Schnee',
  'weather-icon-61': 'Gewitter',
  'weather-icon-62': 'Starke Gewitter',
  'weather-icon-63': 'Donner',
  'weather-icon-64': 'Starker Donner',
  'weather-icon-71': 'Leichte Graupelschauer',
  'weather-icon-72': 'Graupelschauer',
  'weather-icon-73': 'Starke Graupelschauer',
  'weather-icon-81': 'Leichter Schneeregen',
  'weather-icon-82': 'Schneeregen',
  'weather-icon-83': 'Starker Schneeregen',
  'weather-icon-91': 'Feiner Nebel',
  'weather-icon-92': 'Nebel',
  where: 'Wohin?',
  yesterday: 'Gestern',
  zone: 'Tarifzone',
  'zone-info': 'Tarifzone {zone}',
  'zone-unknown': 'Unbekannte Tarifzone',
  zones: 'Tarifzonen',
};

export default de;
